import StockoutSummary from "./stockout-summary.container";

export default StockoutSummary;
